export default __webpack_public_path__ + "static/flag_en-b67ba79ae580ddfc806d7ea97f4d81e8.png";